import React from "react";
import PropTypes from "prop-types";
import DeleteItem from "rialto-icons/DeleteItem";

import UserDetails from "../UserDetails";

import styles from "./UserTag.css";

const UserTag = (props) => {
  const title = [props.user.title, props.user.company.name]
    .filter((string) => !!string)
    .join(" - ");
  const deleteBtn = props.deleteDisabled ? null : (
    <button onClick={props.onDelete}>
      <DeleteItem />
    </button>
  );

  return (
    <div className={styles.wrapper}>
      <UserDetails title={title} user={props.user} />
      {deleteBtn}
    </div>
  );
};

UserTag.propTypes = {
  user: PropTypes.shape({
    fname: PropTypes.string, // eslint-disable-line
    lname: PropTypes.string, // eslint-disable-line
    profilePictureUrl: PropTypes.string,
    title: PropTypes.string, // eslint-disable-line
    company: PropTypes.shape({
      name: PropTypes.string, // eslint-disable-line
    }),
  }).isRequired,
  deleteDisabled: PropTypes.bool,
  onDelete: PropTypes.func,
};

export default UserTag;
